import React, { Component } from "react";
import { get as _get } from "lodash";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";

import { showAlertMessage } from "../../resusableComponents/common/formElements";
import { withRouter } from "../../resusableComponents/hoc/withRouter";

import { getStrategicAnalysisReport } from "../../redux/services/strategicAnalysis";
import { updateLoadingState } from "../../redux/actions/application";

import Template1 from "./components/Template1";

class ViewStrategicAnalysisReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mainClient: "",
      analysisId: _get(this.props, "params.id", 0),
      isLoading: false,
      reportData: {},
      templateId: null,
    };
  }

  componentDidMount() {
    this._fetchReport();
  }

  componentDidUpdate(prevProps) {
    const prevId = _get(prevProps, "params.id", 0);
    const currId = _get(this.props, "params.id", 0);
    if (prevId !== currId) {
      this._fetchReport();
    }
  }

  _fetchReport = async () => {
    const { analysisId } = this.state;
    if (!analysisId) { return; }

    this.setState({ isLoading: true });

    try {
      const response = await getStrategicAnalysisReport(analysisId);

      if (_get(response, "flag", false)) {
        const data = _get(response, "data", {});
        const mainClient = _get(data, "client_name", "");
        const templateId = _get(data, "template_id", null);

        this.setState({
          mainClient,
          reportData: data,
          templateId,
          isLoading: false,
        });
      } else {
        showAlertMessage(_get(response, "message", this.props.intl.formatMessage({ id: "strategic_analysis.view_report.error.fetch_report", defaultMessage: "Something went wrong while fetching report." })));
        this.setState({ isLoading: false });
      }
    } catch (err) {
      showAlertMessage(_get(err, "message", this.props.intl.formatMessage({ id: "strategic_analysis.view_report.error.fetch_report", defaultMessage: "Something went wrong while fetching report." })));
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { isLoading, mainClient, reportData, templateId } = this.state;

    if (isLoading) {
      return (
        <div className="ca-report-wrapper ca-report-wrapper--loading d-flex justify-content-center align-items-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">
              <FormattedMessage id="strategic_analysis.view_report.loading" defaultMessage="Loading..." />
            </span>
          </div>
        </div>
      );
    }

    return (
      <div className="container-fluid flex-grow-1 px-6 py-6">
        <div className="row mb-4">
          <div className="col-lg-7 d-flex align-items-center gap-3">
            <h1 className="heading-04 fw-semibold text-dark-35 text-uppercase mb-0">
              <FormattedMessage
                id="strategic_analysis.view_report.title"
                defaultMessage="Strategic Analysis Report{clientName}"
                values={{ clientName: (mainClient ? ` - ${mainClient}` : "") }}
              />
            </h1>
          </div>
          <div className="col-lg-5 d-flex justify-content-end gap-3">
            <Link
              id="btn-back-to-list"
              className="btn btn-outline-primary waves-effect"
              to="/analysis/strategic-analysis"
            >
              <FormattedMessage id="strategic_analysis.view_report.back_to_report_list" defaultMessage="Back to Report List" />
            </Link>
          </div>
        </div>

        {templateId === 1 && <Template1 reportData={reportData} />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  updateLoadingState: (data) => dispatch(updateLoadingState(data)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(ViewStrategicAnalysisReport)));
